function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import Events from '../utils/events';

function getDistance(a, b) {
  if (!b) return 0;
  return Math.sqrt(Math.pow(b.clientX - a.clientX, 2) + Math.pow(b.clientY - a.clientY, 2));
}

function range(num, min, max) {
  return Math.min(Math.max(num, min), max);
}

var PinchZoom =
/*#__PURE__*/
function (_Component) {
  _inherits(PinchZoom, _Component);

  function PinchZoom(props) {
    var _this;

    _classCallCheck(this, PinchZoom);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PinchZoom).call(this, props));
    _this._container = void 0;
    _this.startTouchX = 0;
    _this.startTouchY = 0;
    _this.moveX = 0;
    _this.moveY = 0;
    _this.startMoveX = 0;
    _this.startMoveY = 0;
    _this.deltaX = 0;
    _this.deltaY = 0;
    _this.moving = false;
    _this.zooming = false;
    _this.scale = 1;
    _this.startScale = void 0;
    _this.prevDistance = 0;
    _this.originHeight = void 0;
    _this.originWidth = void 0;

    _this.getMaxMoveX = function () {
      if (_this.originWidth) {
        return Math.max(0, (_this.scale * _this.originWidth - window.innerWidth) / 2);
      }

      return 0;
    };

    _this.touchstart = function (event) {
      var touches = event.touches;
      _this.startTouchX = touches[0].clientX;
      _this.startTouchY = touches[0].clientY;
      _this.startMoveX = _this.moveX;
      _this.startMoveY = _this.moveY;
      _this.moving = touches.length === 1 && _this.scale !== 1;
      _this.zooming = touches.length === 2;

      if (_this.zooming) {
        _this.startScale = _this.scale;
        _this.prevDistance = getDistance(touches[0], touches[1]);
      }
    };

    _this.updateTransform = function (scale, x, y) {
      var moveX = scale > 1 ? x : 0;
      var moveY = scale > 1 ? y : 0;

      _this._container.current.style.setProperty('--x', "".concat(moveX, "px"));

      _this._container.current.style.setProperty('--y', "".concat(moveY, "px"));

      _this._container.current.style.setProperty('--scale', scale);
    };

    _this.touchmove = function (event) {
      var touches = event.touches;
      _this.deltaX = touches[0].clientX - _this.startTouchX;
      _this.deltaY = touches[0].clientY - _this.startTouchY;

      if (_this.moving) {
        var moveX = _this.deltaX + _this.startMoveX;
        var moveY = _this.deltaY + _this.startMoveY;

        var maxMoveX = _this.getMaxMoveX();

        var maxMoveY = _this.getMaxMoveY();

        _this.moveX = range(moveX, -maxMoveX, maxMoveX);
        _this.moveY = range(moveY, -maxMoveY, maxMoveY);
      }

      var _this$props = _this.props,
          minScale = _this$props.minScale,
          maxScale = _this$props.maxScale,
          onChange = _this$props.onChange;

      if (_this.zooming && touches.length === 2) {
        var distance = getDistance(touches[0], touches[1]);
        var scale = _this.startScale * distance / _this.prevDistance;
        _this.scale = range(minScale, scale, maxScale);
      }

      _this.updateTransform(_this.scale, _this.moveX, _this.moveY);

      if (typeof onChange === 'function') {
        onChange({
          scale: _this.scale,
          x: _this.moveX,
          y: _this.moveY
        });
      }

      if (_this.moving || _this.zooming) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    _this.touchEnd = function (event) {
      var stopPropagation = false;

      if (_this.moving || _this.zooming) {
        stopPropagation = true;

        if (_this.moving && _this.startMoveX === _this.moveX && _this.startMoveY === _this.moveY) {
          stopPropagation = false;
        }

        if (!event.touches.length) {
          if (_this.zooming) {
            _this.moveX = range(_this.moveX, -_this.getMaxMoveX(), _this.getMaxMoveX());
            _this.moveY = range(_this.moveY, -_this.getMaxMoveY(), _this.getMaxMoveY());
            _this.zooming = false;

            _this.updateTransform(_this.scale, _this.moveX, _this.moveY);
          }

          _this.moving = false;
          _this.startTouchX = 0;
          _this.startTouchY = 0;
          _this.startScale = 1;
        }
      }

      if (stopPropagation) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    _this.onload = function (event) {
      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;
      var _event$target = event.target,
          naturalWidth = _event$target.naturalWidth,
          naturalHeight = _event$target.naturalHeight;
      var windowRatio = windowHeight / windowWidth;
      var imageRatio = naturalHeight / naturalWidth;
      var vertical = imageRatio > windowRatio;

      if (vertical) {
        _this.originWidth = windowHeight / imageRatio;
        _this.originHeight = windowHeight;
      } else {
        _this.originWidth = windowWidth;
        _this.originHeight = windowWidth * imageRatio;
      }
    };

    _this._container = React.createRef();
    return _this;
  }

  _createClass(PinchZoom, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      Events.on(this._container.current, 'touchstart', this.touchstart);
      Events.on(document.documentElement, 'touchmove', this.touchmove);
      Events.on(document.documentElement, 'touchend', this.touchEnd);
      Events.on(document.documentElement, 'touchcancel', this.touchEnd);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      Events.off(this._container.current, 'touchstart', this.touchstart);
      Events.off(document.documentElement, 'touchmove', this.touchmove);
      Events.off(document.documentElement, 'touchend', this.touchEnd);
      Events.off(document.documentElement, 'touchcancel', this.touchEnd);
    }
  }, {
    key: "getMaxMoveY",
    value: function getMaxMoveY() {
      if (this.originHeight) {
        return Math.max(0, (this.scale * this.originHeight - window.innerHeight) / 2);
      }

      return 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          prefixCls = _this$props2.prefixCls;
      var child = React.Children.map(children, function (element, index) {
        return React.cloneElement(element, {
          key: +index,
          onLoad: _this2.onload
        });
      });
      return React.createElement("div", {
        ref: this._container,
        className: "".concat(className, " ").concat(prefixCls)
      }, child);
    }
  }]);

  return PinchZoom;
}(Component);

PinchZoom.defaultProps = {
  prefixCls: 'za-pinch-zoom',
  minScale: 1,
  maxScale: 3
};
export { PinchZoom as default };